/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import "./bidReports.styles.scss";
import { ReactComponent as CloseIcon } from "../../assets/cancel.svg";
import { ReactComponent as CheckedIcon } from "../../assets/checked.svg";

import { SyncOutlined } from "@ant-design/icons";

import dayjs from "dayjs";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { getBidReportsUrl } from "../../services/auction-services";

import {
  Table,
  message,
  Button,
  Spin,
  Progress,
  Alert,
  Flex,
  Space,
  Input,
} from "antd";

import CustomFilter from "../../components/custom-filter/custom-filter.component";
import {
  selectSelectedCrop,
  selectCrops,
  selectBranches,
  selectVarieties,
  selectCurrentPage,
  selectViewAuctionPage,
  selectSelectedBranch,
  selectHubs,
} from "../../redux/common/common.selectors";

import Axios from "axios";
import { Dispatch } from "redux";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";
import { dataConstants, FeatureCodes } from "../../constants/data-constants";

import {
  setSelectedBranch,
  setSelectedCrop,
} from "../../redux/common/common.actions";
import { canUserAccess } from "../../utils/utils";
import { useLocation } from "react-router";

const FileDownLoad = require("js-file-download");

const BidReport: React.FC = (props: any) => {
  const {
    branches,
    varietiesList,
    selectedCropId,
    userData,
    crops,
    currentpage,
    viewAuctionPage,
    selectedBranch,
    setSelectedBranchIndex,
    setSelectedCropIndex,
    hubs,
    authData,
  } = props;
  const location = useLocation();
  const [selectedVariety, setSelectedVariety] = useState();
  const [selectedDates, setSelectedDates] = useState([
    dayjs().format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ]);
  const [selectedHub, setSelectedHub] = useState();
  const [isTableVisible, setisTableVisible] = useState(true);
  const [bidReportData, setBidReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isProgressClicked, setisProgressClicked] = useState(false);
  const [downloaddata, setdownloaddata] = useState<any>();
  const [isSpinnerOnProgress, setIsSpinnerOnProgress] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
    showSizeChanger: false,
  });

  const columns = [
    {
      title: "Auction ID",
      key: "auction_num",
      sorter: (a, b) => a.auctionNumber - b.auctionNumber,
      dataIndex: "auctionNumber",
    },
    {
      title: "Auction Date",
      sorter: (a, b) => a.date.localeCompare(b.date),
      dataIndex: "date",
      key: "date2",
    },
    {
      title: "Auction Time",
      sorter: (a, b) => a.time.localeCompare(b.time),
      dataIndex: "time",
      key: "time2",
    },
    {
      title: "Hub",
      sorter: (a, b) => a.hub.localeCompare(b.hub),
      dataIndex: "hub",
      key: "hub2",
    },
    {
      title: "Variety",
      sorter: (a, b) => a.variety.localeCompare(b.variety),
      dataIndex: "variety",
      key: "variety2",
    },
    {
      title: "Claim",
      dataIndex: "claim",
      key: "claim2",
      render: (value: string) => {
        return (
          <div className="claim-container">
            {value === "Yes" ? <CheckedIcon /> : <CloseIcon />}
          </div>
        );
      },
    },
    {
      title: "Rebate ID",
      dataIndex: "rebate_name",
      key: "rebate_name2",
      render: (value: number) => {
        return <div>{value}</div>;
      },
    },
    {
      title: "Division",
      sorter: (a, b) => a.division.localeCompare(b.division),
      dataIndex: "division",
      key: "division2",
      render: (value: number) => {
        return <div>{value}</div>;
      },
    },
    {
      title: "Sauda Type",
      dataIndex: "saudaType",
      key: "saudaType2",
      render: (value: string) => {
        return <div>{value}</div>;
      },
    },
    {
      title: "Rake Sauda",
      dataIndex: "auction_type",
      key: "auction_type",
      render: (value: any) => {
        return <div>{value == 2 || value == 3 ? "Y" : "N"}</div>;
      },
    },
    {
      title: "Auction Status",
      dataIndex: "saudaStatus",
      key: "saudaStatus2",
      render: (value: string) => {
        return (
          <div
            className={`sauda-status ${
              value === "Accept" ? "green" : value === "Reject" ? "red" : ""
            }`}
          >
            {value}
          </div>
        );
      },
    },
    {
      title: `Max Price Entered (₹/${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "maxPrice",
      key: "maxPrice2",
    },
    {
      title: `Qty Required (${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "qtyReqd",
      key: "qtyReqd2",
    },
    {
      title: "Bid ID",
      key: "bidId",
      dataIndex: "bidId",
    },
    {
      title: "Firm Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "Vendor Code",
      key: "vendorCode",
      dataIndex: "vendorCode",
    },
    {
      title: "Bid number",
      key: "bidNumber",
      dataIndex: "bidNumber",
    },
    {
      title: "Time of Bid",
      dataIndex: "timeOfBid",
      key: "timeOfBid2",
      render: (value: number) => {
        if (value === null) {
          return "";
        } else {
          return <div>{dayjs(value, "HH:mm:ss").format("hh:mm a")}</div>;
        }
      },
    },
    {
      title: `Bid Rate (₹/${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "bidPrice",
      key: "bidPrice",
    },
    {
      title: `Allocated Quantity (${
        crops?.find((item) => item.id == selectedCropId)?.unit
      })`,
      dataIndex: "qty",
      key: "qty2",
    },
    {
      title: "Bid Status",
      key: "bidStatus",
      dataIndex: "bidStatus",
      render: (value: string) => {
        return (
          <div
            className={`sauda-status ${
              value === "Accepted" ? "green" : value === "Rejected" ? "red" : ""
            }`}
          >
            {value}
          </div>
        );
      },
    },
    {
      title: "PO Number",
      key: "poNumber",
      dataIndex: "poNumber",
    },
    {
      title: "Remarks",
      key: "remarks",
      dataIndex: "remarks",
    },
    {
      title: "Broker Bid Remarks",
      key: "brokerRemarks",
      dataIndex: "brokerRemarks",
    },
  ];

  useEffect(() => {
    // if (currentpage == "6" && viewAuctionPage === "62") {
    if (location.pathname.includes("/reports/bids")) {
      getBidReportData();
    }
    // onBranchChange(selectedBranch, []);
  }, [
    authData.access_token,
    currentpage,
    viewAuctionPage,
    selectedVariety,
    selectedDates,
    selectedBranch,
    selectedCropId,
    pagination.current,
  ]);
  const filterData = useMemo(() => {
    if (!searchText) return bidReportData;

    return bidReportData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [bidReportData, searchText]);
  useEffect(() => {
    setSelectedVariety(undefined);
  }, [varietiesList]);

  const getBidReportData = async (hubId?: any) => {
    setIsLoading(true);
    setisTableVisible(true);
    const params = {
      start_date: selectedDates[0],
      end_date: selectedDates[1],
      crop_id: selectedCropId,
      branch_id: selectedBranch,
      download: false,
      hub_id: hubId ? (hubId.length ? hubId : undefined) : selectedHub,
      variety_id: selectedVariety,
      page: pagination.current,
    };
    try {
      const response = await getBidReportsUrl(params);
      if (
        response.data.status &&
        response.data.data.data &&
        response.data.data.data.length
      ) {
        const data = response.data.data.data.map((item: any, index: number) => {
          return {
            key: index,
            supplierId: item.supplier_name,
            userName: item.user_name,
            auctionNumber: item.auction_id,
            bidId: item.bid_id,
            date: item.auction_date,
            crop_id: selectedCropId,
            time: item.auction_time,
            branch: item.branch_name,
            hub: item.hub_name,
            variety: item.variety_name,
            claim: item.claim,
            division: item.division,
            saudaType: item.sauda_type,
            saudaStatus: item.auction_status,
            name: item.name_firm,
            role: item.role_name,
            roleId: item.role_id,
            qty: item.alloted_qty === null ? 0 : item.alloted_qty,
            firstBidQty: item.First_bid_qty,
            firstBidRate: item.First_bid_price,
            maxPrice: item.max_price,
            qtyReqd: item.qty_rqd,
            rebate_name: item.rebate_name,
            vendorCode: item.vendor_code,
            bidNumber: item.bid_number,
            timeOfBid: item.bid_time,
            bidStatus: item.bid_status,
            bidPrice: item.bid_price,
            remarks: item.remarks,
            poNumber: item.PO_number,
            qtyFulfilled:
              item.qty_fullfilled === null ? 0 : item.qty_fullfilled,
            brokerRemarks: item.Broker_Bid_Remark,
            auction_type: item.auction_type,
          };
        });
        setPagination((prev) => ({
          ...prev,
          total: response.data.data.total, // total records from backend
        }));
        setBidReportData(data);
      } else {
        setBidReportData([]);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      // message.warning("Something went wrong. Try agin ..!");
      setBidReportData([]);
    }
  };

  const onDateChange = (value: string | number | any, timeString: any) => {
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
    setSelectedDates(timeString);

    // #region disable table view after several days
    /* let start = dayjs(timeString[0]);
    let end = dayjs(timeString[1]);
    let differenceInDays = end.diff(start, "days");

    if (differenceInDays > 14) {
      return setisTableVisible(false);
    } */
  };

  const fileDownload = async () => {
    setIsSpinnerOnProgress(true);
    const body = {
      start_date: selectedDates[0],
      end_date: selectedDates[1],
      branch_id: selectedBranch,
      hub_id: selectedHub,
      variety_id: selectedVariety,
      download: true,
      crop_id: selectedCropId,
    };
    if (process.env.REACT_APP_ENV !== "production") {
      message.success(
        "Mail will send to your official email ID with the report."
      );
      setIsSpinnerOnProgress(false);
      return false;
    }
    //#region file download
    Axios({
      url: dataConstants.bidReportsUrl,
      method: "POST",
      data: body,
      responseType: "blob",
      onDownloadProgress: (progressEvent: any) => {
        let progress = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setdownloaddata(progress);
      },
    })
      .then((response: any) => {
        FileDownLoad(
          response.data,
          `Bidwise_Report_${new Date().toLocaleDateString()}.xlsx`
        );
        message.success("File has been downloaded successfully!");
        setIsSpinnerOnProgress(false);
        setTimeout(
          function () {
            setisProgressClicked(false);
          }.bind(this),
          5000
        );
      })
      .catch((err: any) => {
        message.error("File cannot be downloaded");
        setIsSpinnerOnProgress(false);
        setisProgressClicked(false);
      });
    //#endregion
  };
  const onchange = (page) => {
    setPagination({
      current: page.current,
      pageSize: 20,
      total: 0, // total records from backend
      showSizeChanger: false,
    });
  };
  return (
    <Spin
      spinning={isSpinnerOnProgress}
      tip="Please wait while the file is bieng Downloaded..."
    >
      <div className="bid-report">
        <Flex gap={10} wrap>
          <Space wrap>
            <Input.Search
              placeholder="Search..."
              allowClear
              onSearch={setSearchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: "15em" }}
              variant="outlined"
            />
            <CustomFilter
              type="range-picker"
              head="Date Range"
              startDate={dayjs(selectedDates[0])}
              endDate={dayjs(selectedDates[1])}
              disabledDate={true}
              // disabledDate={[
              //   { startDate: dayjs().subtract(1, "year") },
              //   { endDate: dayjs().add(1, "days") },
              // ]}
              onChange={onDateChange}
            />
            <CustomFilter
              type="single-select"
              value={selectedCropId}
              options={crops}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedCropIndex(value);
              }}
              placeholder="Select Branch"
              head="ITC Branch Office"
              returnId
            />
            <CustomFilter
              type="single-select"
              value={selectedBranch}
              options={branches}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedHub(undefined);
                setSelectedBranchIndex(value);
              }}
              placeholder="Select Branch"
              head="ITC Branch Office"
              returnId
            />
            <CustomFilter
              // type="single-select"
              type="multi-select"
              value={selectedHub}
              options={hubs}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedHub(value);
                getBidReportData(value);
              }}
              placeholder="Select Hub"
              head="Hub"
              returnId
            />
            <CustomFilter
              // type="single-select"
              type="multi-select"
              value={selectedVariety}
              onChange={(value: any) => {
                setPagination((prev) => ({
                  ...prev,
                  current: 1,
                }));
                setSelectedVariety(value);
              }}
              options={varietiesList}
              placeholder="Select Variety"
              head="Variety"
              returnId
            />
          </Space>
          {bidReportData?.length > 0 && (
            <Button
              onClick={() => {
                setdownloaddata(0);
                setisProgressClicked(true);
                fileDownload();
              }}
              // type="primary"
              // shape="round"
              // icon="download"
              // size="large"
              // style={{ display: "block" }}
              className="download-btn-styles"
              disabled={canUserAccess(
                userData,
                FeatureCodes.AUDITOR_VIEW_ONLY_ACCESS
              )}
              loading={isProgressClicked}
            >
              Download
            </Button>
          )}
          <Button
            className="refresh"
            icon={<SyncOutlined spin={isLoading} />}
            onClick={() => getBidReportData()}
          >
            Refresh
          </Button>
        </Flex>
        {isTableVisible ? (
          <div className="auction-report-table-container">
            <Table
              loading={isLoading}
              columns={columns}
              // dataSource={bidReportData}
              dataSource={filterData}
              pagination={pagination}
              onChange={onchange}
              size="small"
              // scroll={{ x: "max-content" }}
              // tableLayout="fixed"
              // footer={() => {
              //   return bidReportData?.length ? (
              //     <div
              //       style={{
              //         display: "flex",
              //         justifyContent: "flex-end",
              //         width: "100%",
              //         alignItems: "baseline",
              //         gap: "1em",
              //         position: "fixed",
              //         right: "5px",
              //       }}
              //     >
              //       <div className="progress-download-container">
              //         {isProgressClicked && (
              //           <Progress
              //             type="circle"
              //             percent={downloaddata}
              //             size={37}
              //             strokeColor={{ "0%": "#108ee9", "100%": "#87d068" }}
              //             style={{
              //               right: "125px",
              //               position: "absolute",
              //               display: "flex",
              //               marginTop: "-47px",
              //             }}
              //             trailColor="#003285"
              //           />
              //         )}
              //       </div>
              //       <div className="download-button-container">
              //         {bidReportData?.length && (
              //           <Button
              //             onClick={() => {
              //               setdownloaddata(0);
              //               setisProgressClicked(true);
              //               fileDownload();
              //             }}
              //             type="primary"
              //             shape="round"
              //             // icon="download"
              //             size="large"
              //             // style={{ display: "block" }}
              //             className="download-btn-styles"
              //           >
              //             <div style={{ marginTop: "-7px" }}>Download</div>
              //             <div
              //               style={{
              //                 fontSize: "11px",
              //                 lineHeight: "7px",
              //                 color: "#b4c8dc",
              //               }}
              //             >
              //               .xls report
              //             </div>
              //           </Button>
              //         )}
              //       </div>
              //     </div>
              //   ) : null;
              // }}
            />
          </div>
        ) : (
          <Alert
            style={{ padding: "10px", width: "50%", margin: "auto" }}
            message="Informational Notes"
            description="The data for the selected time period is too big. You can use the button at the bottom right to download the file"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    setSelectedBranchIndex: (index: number) =>
      dispatch(setSelectedBranch(index)),
    setSelectedCropIndex: (index: number) => dispatch(setSelectedCrop(index)),
  };
};
const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  branches: selectBranches,
  crops: selectCrops,
  varietiesList: selectVarieties,
  selectedCropId: selectSelectedCrop,
  currentpage: selectCurrentPage,
  viewAuctionPage: selectViewAuctionPage,
  selectedBranch: selectSelectedBranch,
  hubs: selectHubs,
  authData: selectAuthData,
});

export default connect(mapStateToProps, mapDispatchToProps)(BidReport);
